import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { allFilterPages, blockLibraryDesignFields } from '@features/filter/static/filterUtil';
import FilterComponent from '@features/filter/v2/FilterComponent';
import CardViewItems from '@features/assets/components/blockLibrary/CardViewItems';

import { setShowItemsCount } from '@store/filter/action';

const BlockLibrary = ({ isShowFilter, setTotalElements }) => {
	const dispatch = useDispatch();

	const filterConfig = {
		filterPageName: allFilterPages.BLOCK_LIBRARY_CARD_VIEW_LIST,
		fields: blockLibraryDesignFields
	};

	const { filterPageName, fields } = filterConfig;

	useEffect(() => {
		dispatch(setShowItemsCount(filterPageName === allFilterPages.BLOCK_LIBRARY_CARD_VIEW_LIST));
	}, [filterPageName, dispatch]);

	return (
		<>
			<section className="filter-data-container filter-v3-data-container under-inner-tabs bg-white">
				<FilterComponent
					filterPageName={filterPageName}
					fields={fields}
					showFilter={isShowFilter}
					isDependentFilter={true}
				/>
				<div className="data-table">
					<CardViewItems setTotalElements={setTotalElements} />
				</div>
			</section>
		</>
	);
};

export default BlockLibrary;
